import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../reducers/feature-key';
import { GenesysCloudWorkItemIntegrationsState } from '../genesys-cloud-work-item-integrations.state';
import { CommunicationType } from '../../conversations/common/models/communication-type.enum';
import { difference, isEmpty, memoize } from 'lodash';
import { selectUserPermissions } from '../../users/selectors/permission.selectors';
import { ConversationBase } from '../../conversations/common/models/conversation-base.model';
import { smartAdvisorIntegration } from '../models/smart-advisor/smart-advisor-integration.constant';
import { journeyIntegration } from '../models/journey-integration.constant';
import { externalContactIntegration } from '../models/external-contact-integration.constant';

const DEFAULT_COMMUNICATION_TYPES = Object.values(CommunicationType);
const DEFAULT_CONVERSATION_FILTER = () => true;

export const selectDefaultIntegrationPanels = createSelector(() => [
  smartAdvisorIntegration,
  journeyIntegration,
  externalContactIntegration
]);

export const selectState = createFeatureSelector<GenesysCloudWorkItemIntegrationsState>(featureKey);
export const selectIntegrations = createSelector(selectState, state => state.integrations);
export const selectOpenIntegrationPanels = memoize((conversationId: string) =>
  createSelector(selectState, state => state.openIntegrationPanels[conversationId.toString()])
);
export const selectAllowedIntegrations = createSelector(
  selectIntegrations,
  selectUserPermissions,
  (integrations, userPermissions) => integrations.filter(
    ({ permissions = [] }) => isEmpty(difference(permissions, userPermissions))
  )
);
export const selectIntegrationsByConversation = memoize((conversation: ConversationBase) => createSelector(
  selectAllowedIntegrations,
  i => i.filter(({ communicationTypes = DEFAULT_COMMUNICATION_TYPES, conversationFilter = DEFAULT_CONVERSATION_FILTER }) => {
    return communicationTypes.includes(conversation.communicationType) && conversationFilter(conversation);
  })
), (conversation: ConversationBase) => conversation.id );

